import { render, staticRenderFns } from "./OldRejected.vue?vue&type=template&id=5b7fb121&"
import script from "./OldRejected.vue?vue&type=script&lang=js&"
export * from "./OldRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports